import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@d-guards/auth-guard';

import { MasterLayoutComponent } from './layout/layout.component';

import { MODULE_CODE_PERMISSION } from '@d-constants/permission.constant';
import { PermissionGuard } from '@d-guards/permission.guard';
import { LoginComponent } from './modules/login/login.component';
import { NotFoundComponent } from './modules/not-found/not-found.component';
import { LevelGuard } from '@d-guards/level.guard';
import { CallbackComponent } from '@d-modules/call-back/call-back.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/home',
  },
  {
    path: '',
    component: MasterLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'home',
        loadChildren: () =>
          import('./modules/home/home/home.module').then((m) => m.HomeModule),
        data: { title: 'HOME' },
      },
      // {
      //   path: 'merchant-management',
      //   loadChildren: () =>
      //     import('./modules/merchant/merchant.module').then(
      //       (m) => m.MerchantModule,
      //     ),
      //   data: {
      //     title: 'MERCHANT_MANAGEMENT',
      //     isPOLocated: false,
      //   },
      //   canActivate: [LevelGuard],
      // },
      {
        path: 'merchant-management-v2',
        loadChildren: () =>
          import('./modules/merchant-v2/merchant-v2.module').then(
            (m) => m.MerchantV2Module,
          ),
        data: {
          title: 'MERCHANT_MANAGEMENT',
          isPOLocated: false,
        },
      },
      {
        path: 'asset-management',
        loadChildren: () =>
          import('./modules/asset/asset.module').then((m) => m.AssetModule),
        data: {
          title: 'ASSET_MANAGEMENT',
          isPOLocated: false,
        },
      },
      {
        path: 'work-order',
        loadChildren: () =>
          import('./modules/work-order/work-order.module').then(
            (m) => m.WorkOrderModule,
          ),
        data: {
          title: 'WORK_ORDER_MANAGEMENT',
          moduleCode: MODULE_CODE_PERMISSION.WORK_ORDER_MANAGEMENT.WORK_ORDER,
          isPOLocated: false,
        },
        canActivate: [PermissionGuard],
      },
      {
        path: 'reporting',
        loadChildren: () =>
          import('./modules/reporting/reporting.module').then(
            (m) => m.ReportingModule,
          ),
        data: {
          title: 'REPORTING',
          moduleCode: MODULE_CODE_PERMISSION.REPORTING.Subsidy_OP_Reporting,
          isPOLocated: false,
        },
        // canActivate: [LevelGuard],
      },
      {
        path: 'access-control',
        loadChildren: () =>
          import('./modules/access-control/access-control.module').then(
            (m) => m.AccessControlModule,
          ),
        data: {
          title: 'USER_ACCESS_MANAGEMENT',
          isPOLocated: false,
        },
        // canActivate: [LevelGuard],
      },
      // {
      //   path: 'reporting',
      //   loadChildren: () =>
      //     import('./modules/reporting/reporting.module').then(
      //       (m) => m.ReportingModule,
      //     ),
      //   data: {
      //     title: 'REPORTING',
      //     moduleCode: MODULE_CODE_PERMISSION.REPORTING,
      //     isPOLocated: false,
      //   },
      //   canActivate: [LevelGuard],
      // },
      // {
      //   path: 'programme',
      //   loadChildren: () =>
      //     import('./modules/programme/programme.module').then(
      //       (m) => m.ProgramModule,
      //     ),
      //   data: {
      //     title: 'PROGRAMME_MANAGEMENT',
      //     moduleCode:
      //       MODULE_CODE_PERMISSION.PROGRAM_MANAGEMENT.WMS_OP_POProgramMgmt,
      //     isPOLocated: true,
      //   },
      //   canActivate: [LevelGuard],
      // },
      // {
      //   path: 'programme-type-group',
      //   loadChildren: () =>
      //     import(
      //       './modules/programme-type-group/programme-type-group.module'
      //     ).then((m) => m.ProgrammeTypeGroupModule),
      //   data: {
      //     title: 'PROGRAM_TYPE_GROUP',
      //     moduleCode:
      //       MODULE_CODE_PERMISSION.PROGRAM_TYPE_GROUP.WMS_ProgramTypeGroup,
      //     isPOLocated: false,
      //   },
      //   canActivate: [LevelGuard],
      // },
      // {
      //   path: 'programme-type',
      //   loadChildren: () =>
      //     import('./modules/programme-type/programme-type.module').then(
      //       (m) => m.ProgrammeTypeModule,
      //     ),
      //   data: {
      //     title: 'PROGRAM_TYPE',
      //     moduleCode: MODULE_CODE_PERMISSION.PROGRAM_TYPE.WMS_OP_POProgramType,
      //     isPOLocated: true,
      //   },
      //   canActivate: [PermissionGuard, LevelGuard],
      // },
      // {
      //   path: 'product-management',
      //   loadChildren: () =>
      //     import('./modules/product-management/product-management.module').then(
      //       (m) => m.ProductManagementModule,
      //     ),
      //   data: {
      //     title: 'PRODUCT_MANAGEMENT',
      //     isPOLocated: false,
      //   },
      //   canActivate: [LevelGuard],
      // },
      // {
      //   path: 'program-owner',
      //   loadChildren: () =>
      //     import('./modules/program-owner/program-owner.module').then(
      //       (m) => m.ProgramOwnerModule,
      //     ),
      //   data: {
      //     title: 'PROGRAM_OWNER_MANAGEMENT',
      //     moduleCode: [
      //       MODULE_CODE_PERMISSION.PROGRAM_OWNER_PROFILE.WMS_OP_POProfile,
      //       MODULE_CODE_PERMISSION.PROGRAM_OWNER_MANAGEMENT
      //         .WMS_ProgramOwnerMgmt,
      //     ],
      //   },
      // },
      // {
      //   path: 'settlement',
      //   loadChildren: () =>
      //     import('./modules/settlement/settlement.module').then(
      //       (m) => m.SettlementModule,
      //     ),
      //   data: {
      //     title: 'SETTLEMENT',
      //     isPOLocated: false,
      //   },
      //   canActivate: [LevelGuard],
      // },

      // {
      //   path: 'tenant-profile',
      //   loadChildren: () =>
      //     import('./modules/tenant-profile/tenant-profile.module').then(
      //       (m) => m.TenantProfileModule,
      //     ),
      //   data: {
      //     title: 'TENANT_PROFILE',
      //     isPOLocated: false,
      //   },
      //   canActivate: [LevelGuard],
      // },
      // {
      //   canActivate: [PermissionGuard, LevelGuard],
      //   path: 'donor',
      //   loadChildren: () =>
      //     import('./modules/donor/donor.module').then((m) => m.DonorModule),
      //   data: {
      //     title: 'DONORS_MANAGEMENT',
      //     moduleCode: MODULE_CODE_PERMISSION.DONOR_MANAGEMENT.WMS_OP_PODonor,
      //     isPOLocated: true,
      //   },
      // },
      // {
      //   canActivate: [PermissionGuard, LevelGuard],
      //   path: 'card-management',
      //   loadChildren: () =>
      //     import('./modules/card-management/card-management.module').then(
      //       (m) => m.CardManagementModule,
      //     ),
      //   data: {
      //     title: 'CARD_MANAGEMENT',
      //     moduleCode:
      //       MODULE_CODE_PERMISSION.CARD_MANAGEMENT.WMS_OP_PORecipientCard,
      //     isPOLocated: true,
      //   },
      // },

      {
        path: 'settings',
        loadChildren: () =>
          import('./modules/settings/settings.module').then(
            (m) => m.SettingsModule,
          ),
        data: {
          title: 'SETTINGS',
          moduleCode: [MODULE_CODE_PERMISSION.SETTINGS_TENANT_LEVEL],
        },
        canActivate: [PermissionGuard],
      },
      // {
      //   path: 'recipient-management',
      //   loadChildren: () =>
      //     import(
      //       './modules/recipient-management/recipient-management.module'
      //     ).then((m) => m.RecipientManagementModule),
      //   data: {
      //     title: 'RECIPIENT_MANAGEMENT',
      //     moduleCode:
      //       MODULE_CODE_PERMISSION.RECIPIENT_MANAGEMENT
      //         .WMS_OP_POManageRecipient,
      //     isPOLocated: true,
      //   },
      //   canActivate: [LevelGuard],
      // },
      // {
      //   path: 'community-management',
      //   loadChildren: () =>
      //     import('./modules/community/community-management.module').then(
      //       (m) => m.CommunityManagementModule,
      //     ),
      //   data: {
      //     title: 'COMMUNITY_MANAGEMENT',
      //     moduleCode:
      //       MODULE_CODE_PERMISSION.COMMUNITY_MANAGEMENT
      //         .WMS_OP_POManageCommunities,
      //     isPOLocated: true,
      //   },
      //   canActivate: [PermissionGuard, LevelGuard],
      // },
      // {
      //   path: 'application-management',
      //   loadChildren: () =>
      //     import(
      //       './modules/application-management/application-management.module'
      //     ).then((m) => m.ApplicationManagementModule),
      //   data: {
      //     title: 'APPLICATION_MANAGEMENT',
      //     moduleCode: MODULE_CODE_PERMISSION,
      //     isPOLocated: true,
      //   },
      //   canActivate: [LevelGuard],
      // },
      // {
      //   path: 'exception-management',
      //   data: {
      //     title: 'EXCEPTION_MANAGEMENT',
      //     moduleCode:
      //       MODULE_CODE_PERMISSION.EXCEPTION_MANAGEMENT.WMS_OP_ExceptionMgmt,
      //     isPOLocated: false,
      //   },
      //   canActivate: [PermissionGuard, LevelGuard],
      //   loadChildren: () =>
      //     import(
      //       './modules/exception-management/exception-management.module'
      //     ).then((m) => m.ExceptionManagementModule),
      // },
    ],
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'not-found',
    component: NotFoundComponent,
  },
  {
    path: 'callback',
    pathMatch: 'full',
    component: CallbackComponent,
    // redirectTo: '/home',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
